import React from "react";
import IncidentReport from "../../../component/Incident/IncidentReport";

const IncidentReportScreen = () => {
  return (
    <div>
      <IncidentReport />
    </div>
  );
};

export default IncidentReportScreen;
